import { Availability } from '../AvailabilityView';
import { Box, Container } from '@chakra-ui/react';
import { PickerEmptyState, PickerField, PickerRow } from './pickerUi';
import { useEffect, useState } from 'react';

export const PickerKM = (props: any) => {
	const [isValidating] = useState(false);
	const [subject, setSubject] = useState('');
	const [level, setLevel] = useState('');
	const [isMobileCollapsed, setIsMobileCollapsed] = useState(false);
	const isFilled = Boolean(subject && level);

	useEffect(() => {
		if (isFilled) setIsMobileCollapsed(true);
	}, [isFilled]);

	const handleSubjectChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
		const nextSubject = event.currentTarget.value;
		setSubject(nextSubject);
		setLevel(['mat', 'pol', 'ang'].includes(nextSubject) ? '' : 'MR');
	};

	const getCode = () => {
		return `${subject}_kurs_${level}`;
	};

	const renderLevelForSubject = (subject: any) => {
		switch (subject) {
			case 'mat':
			case 'pol':
			case 'ang':
				return [
					<option value="MP" key="MP">
						podstawowy
					</option>,
					<option value="MR" key="MR">
						rozszerzony
					</option>,
				];
			default:
				return <option value="MR">rozszerzony</option>;
		}
	};

	return (
        <Box pb={2}>
            <PickerRow
                collapsible={isFilled}
                isCollapsed={isMobileCollapsed}
                onToggleCollapse={() => setIsMobileCollapsed((value) => !value)}
            >
                <PickerField
                    label="Przedmiot"
                    value={subject}
                    invalid={!subject && isValidating}
                    placeholder="- przedmiot -"
                    onChange={handleSubjectChange}
                >
                    <option value="mat">matematyka</option>
                    <option value="pol">j. polski</option>
                    <option value="ang">j. angielski</option>
                    <option value="fiz">fizyka</option>
                    <option value="chemia">chemia</option>
                    <option value="geo">geografia</option>
                    <option value="his">historia</option>
                    <option value="bio">biologia</option>
                </PickerField>
                <PickerField
                    label="Poziom"
                    value={level}
                    invalid={!level && isValidating}
                    placeholder="- poziom -"
                    onChange={(event) => setLevel(event.currentTarget.value)}
                >
                    {renderLevelForSubject(subject)}
                </PickerField>
            </PickerRow>
            {isFilled ? (
				<Availability
					code={getCode()}
					type="KM"
					onPick={(lesson: any) =>
						props.onPick({
							...lesson,
							subjectCode: subject,
							kind: 'Kurs maturalny',
						})
					}
				/>
			) : (
				<Container centerContent>
					<PickerEmptyState />
				</Container>
			)}
        </Box>
    );
};
